$.fn.payRatio = function() {

  var container = $(this);

  return this.each(function() {

    container.find('.calc').on('propertychange change click keyup input paste', function() {
      calculation(container);
    });

  });

  // calculate
  function calculation(c) {

    // collect elements
    var e01 = c.find('[name="tool_elem_01"]'), // input
        e02 = c.find('[name="tool_elem_02"]'), // input
        e03 = c.find('[name="tool_elem_03"]'), // output
        e04 = c.find('[name="tool_elem_04"]'), // input
        e05 = c.find('[name="tool_elem_05"]'), // output
        e06 = c.find('[name="tool_elem_06"]'), // input
        e07 = c.find('[name="tool_elem_07"]'); // output
    
    var e08 = c.find('#result_value');

    // collect values
    var v01 = parseInt((e01.val()).replace(/\./g,'')),
        v02 = parseInt((e02.val()).replace(/\./g,'')),
        v03 = parseInt((e03.val()).replace(/\./g,'')),
        v04 = parseInt((e04.val()).replace(/\./g,'')),
        v05 = parseInt((e05.val()).replace(/\./g,'')),
        v06 = parseInt((e06.val()).replace(/\./g,'')),
        v07 = parseInt((e07.val()).replace(/\./g,''));

    if (!isNaN(v01) && !isNaN(v02)) {
      e03.val((v01-v02).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."));
    }

    if (!isNaN(v03) && !isNaN(v04)) {
      e05.val(Math.round(v03/v04).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."));
    }

    if (!isNaN(v02) && !isNaN(v06)) {
      e07.val(Math.round(v02/v06).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."));
    }

    e08.html(Math.round(v07/v05*10)/10);

    // console.log(v01);
    // console.log(v02);
    // console.log(v04);
    // console.log(v06);

    if (!isNaN(v01) && !isNaN(v02) && !isNaN(v04) && !isNaN(v06) && isFinite(Math.round(v07/v05*10)/10)) {
      c.find('.tool-result, .tool-print').slideDown();
    } else {
      c.find('.tool-result, .tool-print').slideUp();
    }

    // console.log('--------------------------');

  }
};
